module.exports = __webpack_public_path__ + "img/hangup.543d27fc.png";